import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styled from 'styled-components'
import { useTransition, animated } from 'react-spring'
import BetCard from './Betslip/BetCard'
import EmptyState from './EmptyState'

const Subheader = styled.div`
  padding-top: ${props => props.theme.spacing(2)}px;
  padding-left: ${props => props.theme.spacing(4)}px;
  padding-right: ${props => props.theme.spacing(4)}px;
  display: flex;
  align-items: center;
`
const SubheaderTitle = styled.p`
  color: ${props => props.theme.palette.text.secondary};
  font-size: 0.875rem;
  flex: 1;
  margin: 0;
`

const renderSubheader = title => (
  <Subheader>
    <SubheaderTitle>{title}</SubheaderTitle>
  </Subheader>
)

const OpenBets = openBetProps => {
  const { bets } = openBetProps
  const isEmpty = _.isEmpty({ ...bets })
  // Let's group all bets placed by user under 'today'
  // Lets store the older bets to help with organising subheaders
  // Yesterday, Last Week etc
  // For the time let's group all bets from the user's history
  // object under 'yesterday'
  const olderBets = []

  const betsArray = Object.keys(bets).map(item => bets[item])

  const BetCardAnimation = useTransition(betsArray, item => item.betKey, {
    config: { tension: 250 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  if (isEmpty) {
    return (
      <EmptyState
        key="open"
        section="openBets"
        title="Open Bets is empty"
        text="Currently there are no open bets"
      />
    )
  }

  return BetCardAnimation.reverse().map(({ item, key, props }, index) => {
    const {
      id,
      sport,
      competition,
      marketTitle,
      name,
      odds,
      slug,
      date,
      start,
      freebet, // we need later
      returns,
      stake,
      timeBetPlaced,
      straight,
      result, // will need later for bet history
      betKey,
    } = item

    if (!timeBetPlaced) {
      olderBets.push(item)
    }

    // Display a start time for multi bets
    const displayMultiStartTime = () => {
      if (_.isEmpty(straight)) {
        return
      }
      const multiStartTime = Object.keys(straight.bets).map(
        leg => `${straight.bets[leg].date} ${straight.bets[leg].start}`
      )
      // for the time being lets return the first start value
      // TODO - add epoch to addToSlip function
      return multiStartTime[0]
    }

    // List out the multi selections to be displayed on the betcard
    const displayMultiLegs = () => {
      if (_.isEmpty(straight)) {
        return
      }
      const multiLegs = Object.keys(straight.bets).map(
        (leg, i) =>
          `${i === 0 ? `` : `, `}${straight.bets[leg].name} @ ${
            straight.bets[leg].odds
          }`
      )
      return multiLegs
    }

    return (
      <Fragment key={key}>
        {index === 0 && timeBetPlaced && renderSubheader('Today')}
        {olderBets.length <= 1 &&
          !timeBetPlaced &&
          renderSubheader('Yesterday')}
        <animated.div style={props}>
          <BetCard
            id={id}
            sport={sport}
            competition={competition}
            marketTitle={marketTitle || null}
            name={name || straight.title}
            odds={odds || straight.odds}
            slug={slug || null}
            multiLegs={straight ? displayMultiLegs() : null}
            date={date || displayMultiStartTime()}
            start={start || null}
            freebet={false}
            returns={returns || straight.odds * straight.stake}
            stake={stake || straight.stake}
            cashout
            betKey={betKey}
            betDetails={item}
          />
        </animated.div>
      </Fragment>
    )
  })
}

OpenBets.propTypes = {
  bets: PropTypes.object.isRequired,
}

export default OpenBets
